import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, finalize, map } from 'rxjs/operators';
import { StorageService } from '../core/services/storage.service';
import { AuthService } from '../auth/services/auth.service';
import { ConfigService } from '../core/services/config.service';
import { User } from '../core/interfaces';
import { LoadingService } from '../core/loading/services/loading.service';

@Injectable({
  providedIn: 'root',
})
export class PagesResolverService implements Resolve<boolean> {
  constructor(
    private storageService: StorageService,
    private authService: AuthService,
    private configService: ConfigService,
    private loadingService: LoadingService,
  ) {}

  resolve(route: ActivatedRouteSnapshot): Observable<boolean> {
    const token = this.storageService.Get('cropmap_token');
    const userInfo: User = this.storageService.Get('cropmap_userInfo');

    if (!token || !userInfo?.CropMapRoleId || !userInfo?.EnterpriseId) {
      return this.handleUnauthorized();
    }

    if (this.configService.enterpriseConfig && this.configService.userRole) {
      return of(true); // Already loaded, no need for further resolution
    }

    this.authService.userInfo = userInfo;

    this.loadingService.showLoading(true);
    return this.configService.getEnterpriseAndRole(userInfo.EnterpriseId, userInfo.CropMapRoleId).pipe(
      finalize(() => {
        setTimeout(() => {
          this.loadingService.hideLoading(true);
        }, 1000);
      }),
      map((res) => {
        if (res) {
          return true;
        }
        return this.logOutAndReturnFalse();
      }),
      catchError(async () => this.logOutAndReturnFalse()),
    );
  }

  private logOutAndReturnFalse(): boolean {
    this.authService.logOut();
    return false;
  }

  private handleUnauthorized(): Observable<boolean> {
    this.authService.logOut();
    return of(false);
  }
}
